import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'react-clock/dist/Clock.css';

import Router from './routes';
import ThemeProvider from './theme';
import { StyledChart } from './components/chart';
import ScrollToTop from './components/scroll-to-top';
import ErrorBoundary from './components/ErrorBoundary';

import { store } from './redux/store';
import { NotificationProvider } from './context/NotificationContext';

export default function App() {
  return (
    <Provider store={store}>
      <ToastContainer
        position={toast.POSITION.BOTTOM_RIGHT}
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
      />

      <ErrorBoundary>
        <HelmetProvider>
          <NotificationProvider>
            <BrowserRouter>
              <ThemeProvider>
                <ScrollToTop />
                <StyledChart />
                <Router />
              </ThemeProvider>
            </BrowserRouter>
          </NotificationProvider>
        </HelmetProvider>
      </ErrorBoundary>
    </Provider>
  );
}
